<template>
	<a-modal v-model="visible" title="编辑活动信息" width="800px" @ok="doSubmit" @cancel="close" centered destroyOnClose :confirmLoading="loading">
		<a-form-model ref="formRef" :model="formData" label-position="top">
			<a-row :gutter="12">
				<a-col :span="10">
					<a-form-model-item label="活动标题" prop="title" :rules="{ required: true, message: '请输入活动标题' }">
						<a-input v-model="formData.title" placeholder="请输入活动标题" />
					</a-form-model-item>
				</a-col>
				<a-col :span="6">
					<a-form-model-item label="活动状态" prop="status" :rules="{ required: true, message: '请选择活动状态' }">
						<a-select v-model="formData.status" button-style="solid" style="width: 100%">
							<a-select-option :value="0">未开始</a-select-option>
							<a-select-option :value="1">进行中</a-select-option>
							<a-select-option :value="2">已结束</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="所属单位" prop="organId" :rules="{ required: true, message: '请选择所属单位' }">
						<choose-organ v-model="formData.organId" style="width: 100%"></choose-organ>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row :gutter="12">
				<a-col :span="6">
					<a-form-model-item label="商家报名截止时间" prop="applyEndTime" :rules="{ required: true, message: '请选择报名截止时间' }">
						<a-date-picker valueFormat="YYYY-MM-DD HH:mm" showTime v-model="formData.applyEndTime" allowClear format="YYYY-MM-DD HH:mm" />
					</a-form-model-item>
				</a-col>
				<a-col :span="6">
					<a-form-model-item style="width: 90%" label="活动开始时间" prop="startTime" :rules="{ required: true, message: '请选择活动开始时间' }">
						<a-date-picker valueFormat="YYYY-MM-DD HH:mm" showTime v-model="formData.startTime" allowClear format="YYYY-MM-DD HH:mm" />
					</a-form-model-item>
				</a-col>
				<a-col :span="6">
					<a-form-model-item label="活动截止时间" prop="endTime" :rules="{ required: true, message: '请选择活动截止时间' }">
						<a-date-picker valueFormat="YYYY-MM-DD HH:mm" showTime v-model="formData.endTime" allowClear format="YYYY-MM-DD HH:mm" />
					</a-form-model-item>
				</a-col>
				<a-col :span="6">
					<a-form-model-item label="显示统计信息到前端" prop="showStats">
						<a-select v-model="formData.showStats">
							<a-select-option :value="1">显示</a-select-option>
							<a-select-option :value="0">不显示</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row :gutter="12">
				<a-col :span="24">
					<a-form-model-item label="活动简介" prop="description">
						<a-textarea v-model="formData.description" :rows="4" placeholder="请输入活动简介"></a-textarea>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="活动海报" prop="poster">
						<up-img ref="upimg" @success="e => (formData.poster = e)" :thumb="formData.poster"></up-img>
					</a-form-model-item>
				</a-col>
			</a-row>
			<!-- <a-row :gutter="12">
				<a-col :span="24">
					<a-form-model-item label="活动详情" prop="content" label-position="top">
						<editor v-model="formData.content" />
					</a-form-model-item>
				</a-col>
			</a-row> -->
		</a-form-model>
	</a-modal>
</template>

<script>
import apiUtils from '@/common/apiUtil';
import editor from '@/components/component/editor.vue';
import upImg from '@/components/common/upImg.vue';

export default {
	components: { editor, upImg },
	data() {
		return {
			visible: false,
			loading: false,
			formData: {
				activityId: '',
				title: '',
				poster: '',
				description: '',
				content: '',
				startTime: '',
				endTime: '',
				applyEndTime: '',
				showStats: 1,
				status: 0,
				organId: apiUtils.getDefaultOrganId()
			}
		};
	},
	methods: {
		show(row) {
			this.visible = true;
			if (row && row.activityId) {
				this.formData = Object.assign({}, row);
			} else {
				this.formData = {
					activityId: '',
					title: '',
					poster: '',
					description: '',
					content: '',
					startTime: '',
					endTime: '',
					applyEndTime: '',
					showStats: 1,
					status: 0,
					organId: apiUtils.getDefaultOrganId()
				};
			}
			this.$nextTick(() => {
				this.$refs.formRef && this.$refs.formRef.clearValidate();
			});
		},
		close() {
			this.visible = false;
		},
		doSubmit() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					this.loading = true;
					const url = this.formData.activityId ? '/platform/activity/edit' : '/platform/activity/add';
					this.http
						.post(url, this.formData)
						.then(ret => {
							if (ret.code == 200) {
								this.utils.success('操作成功！').then(() => {
									this.close();
									this.$emit('success');
								});
							}
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		}
	}
};
</script>
